/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, ReactNode, useContext } from "react";

type PlayerFeatures = {
  autoPlay: boolean;
  continueWatching: boolean;
  nextEpisode: boolean;
  trackAnalytics: boolean;
  withClientSideAds: boolean;
};

type PlayerFeaturesProviderProps = PlayerFeatures & {
  children: ReactNode;
};

type PlayerFeaturesContextValue = PlayerFeatures;

const PlayerFeaturesContext = createContext<PlayerFeaturesContextValue>(
  {} as PlayerFeaturesContextValue,
);

export const PlayerFeaturesProvider = (props: PlayerFeaturesProviderProps) => {
  const { children, ...features } = props;

  return (
    <PlayerFeaturesContext.Provider value={{ ...features }}>
      {children}
    </PlayerFeaturesContext.Provider>
  );
};

export const usePlayerFeatures = (): PlayerFeaturesContextValue => {
  const context = useContext(PlayerFeaturesContext);

  if (!context) {
    throw new Error("Component beyond PlayerFeaturesContext");
  }

  return context;
};
